module.exports = __webpack_public_path__ + "img/plussss.cf050959.png";